import React, { FC } from 'react'
import { Trans, t } from '@lingui/macro'

import ResettableInput from '../../../components/common/form/input/ResettableInput'
import Select, { SelectVariant } from '../../../components/common/select/Select'

import './Filters.less'
import { css } from '@emotion/react'

export type PathwaysPageFilterProps = {
  value: boolean | null
  label: string | JSX.Element
}

export interface IProps {
  search: string
  state: PathwaysPageFilterProps
  sort: PathwayOrderOptions
  onSearchChange: (
    search: string,
    state: PathwaysPageFilterProps,
    sort: PathwayOrderOptions
  ) => void
}
export const pathwayStateSelectOptions = [
  {
    value: null,
    label: <Trans>All</Trans>
  },
  {
    value: false,
    label: <Trans>Draft</Trans>
  },
  {
    value: true,
    label: <Trans>Published</Trans>
  }
]

type OrderingType = 'desc' | 'asc'
export type PathwayOrderOptions = {
  label: string | JSX.Element
  value: { name: string; sort: OrderingType }
}
export const pathwayOrderingOptions: PathwayOrderOptions[] = [
  {
    value: { name: 'order', sort: 'asc' },
    label: <Trans>Manual sorting for learners</Trans>
  },
  {
    value: { name: 'title', sort: 'asc' },
    label: <Trans>Name Ascending</Trans>
  },
  {
    value: { name: 'title', sort: 'desc' },
    label: <Trans>Name Descending</Trans>
  },
  {
    value: { name: 'created_at', sort: 'asc' },
    label: <Trans>Date Created Ascending</Trans>
  },
  {
    value: { name: 'created_at', sort: 'desc' },
    label: <Trans>Date Created Descending</Trans>
  }
]

const PathwaysPageFilters: FC<IProps> = (props: IProps) => {
  const { search, state, sort, onSearchChange } = props

  return (
    <>
      <label className="FilterSelect">
        <Select
          labelClassName="FilterSelect__label"
          label={<Trans>Status</Trans>}
          className="Select--filter"
          variant={SelectVariant.WHITE}
          controlWidth={200}
          css={css`
            margin-right: 16px;
          `}
          options={pathwayStateSelectOptions}
          value={state}
          // @ts-expect-error 9/11/2020
          onChange={(v: PathwaysPageFilterProps) => {
            onSearchChange(search, v, sort)
          }}
        />
      </label>

      <label className="FilterSelect">
        <Select
          label={<Trans>Order</Trans>}
          labelClassName="FilterSelect__label"
          className="FSelect--filter"
          variant={SelectVariant.WHITE}
          controlWidth={300}
          css={css`
            min-width: 240px;
            margin-right: 8px;
          `}
          options={pathwayOrderingOptions}
          value={pathwayOrderingOptions.find((option) => option === sort)}
          // @ts-expect-error
          onChange={(v: PathwayOrderOptions) => {
            onSearchChange(search, state, v)
          }}
        />
      </label>

      <ResettableInput
        onChange={(v) => onSearchChange(v, state, sort)}
        title={t`Search`}
        placeholder={t`Search`}
        showResetButton={Boolean(search)}
        showSearchIcon={true}
        light={true}
        value={search}
        onReset={() => onSearchChange('', state, sort)}
      />
    </>
  )
}

export default PathwaysPageFilters
